import React from 'react';
import {Button, Input, Modal, Table, message} from 'antd';
import {getNewOutlet, getOutlet, useOutlet} from 'reconnect.js';
import * as Jstorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../../AppActions';
import useDocuments from '../../Hooks/useDocuments';

getNewOutlet('admin-search-product-modal', null, {autoDelete: false});

export function showAdminSearchProductModal(data) {
  getOutlet('admin-search-product-modal').update(data);
}

const collection = 'root-product';

export default function AdminSearchProductModal(props) {
  const [data, setData] = useOutlet('admin-search-product-modal');

  const {records, total, refresh, filters, setFilters, loading} = useDocuments({
    collection,
  });

  React.useEffect(() => {
    if (!!data) {
      refresh();
    }
  }, [refresh, !!data]);

  function onClose() {
    setFilters((prev) => ({
      ...prev,
      offset: 0,
      sku: '',
    }));
    setData(null);
  }

  return (
    <Modal
      visible={!!data}
      onCancel={onClose}
      footer={null}
      width={1000}
      closable={false}
      maskClosable={true}
      destroyOnClose={true}>
      <div>
        <Input.Search
          style={{marginBottom: 10}}
          placeholder="搜尋名稱"
          allowClear
          onSearch={async (value) => {
            setFilters((prev) => ({
              ...prev,
              offset: 0,
              sku: value, // {$regex: value},
            }));
          }}
        />

        <Table
          dataSource={records}
          columns={[
            {
              key: 'name',
              title: '名稱',
              dataIndex: 'sku',
            },

            {
              key: '',
              title: '',
              dataIndex: '',
              render: (_, item) => {
                return (
                  <Button
                    onClick={() => {
                      data.onChange(item.id);
                      onClose();
                    }}>
                    選擇
                  </Button>
                );
              },
            },
          ]}
          rowKey="id"
          locale={{emptyText: '無商品資料'}}
          scroll={{x: 500, y: 300}}
          pagination={{
            total,
            pageSize: filters.limit,
            current: filters.offset / filters.limit + 1,
            showSizeChanger: false,
          }}
          onChange={({pageSize, current}) => {
            setFilters((prev) => ({
              ...prev,
              offset: (current - 1) * prev.limit,
            }));
          }}
        />
      </div>
    </Modal>
  );
}
